/**
 * Normalizes the keys of URLSearchParams to lowercase.
 * 
 * @param {URLSearchParams} searchParams - The URLSearchParams object to normalize.
 * @returns {URLSearchParams} - A new URLSearchParams object with keys normalized to lowercase.
 */
export default function normalizeSearchParams(searchParams) {
    const normalizedParams = new URLSearchParams();
  
    for (const [key, value] of searchParams.entries()) {
        normalizedParams.set(key.toLowerCase(), value);
    }
  
    return normalizedParams;
}